import { isGroupedFilters } from '@/utils/QueryHelpers'
import { CompositeFilterDescriptor } from '@progress/kendo-data-query'

const IB_REBATES_GROUP_SETTINGS_PREFIXED_FIELDS = new Set(['TradingAccountsCount'])

export const prefixGroupFilterValues = (
  filter: CompositeFilterDescriptor,
  brokerId: string
): CompositeFilterDescriptor => ({
  ...filter,
  filters: filter.filters.map((f) => {
    if (isGroupedFilters(f)) {
      return prefixGroupFilterValues(f, brokerId)
    }
    if (
      typeof f.field === 'string' &&
      IB_REBATES_GROUP_SETTINGS_PREFIXED_FIELDS.has(f.field) &&
      f.value !== undefined &&
      f.value !== null
    ) {
      return { ...f, value: `${brokerId}__${f.value}` }
    }
    return f
  }),
})
